import React from "react";
import { Loading } from "..";
import { QuestionInterface, AnswerInterface, ArrayHelper, PendingCommand } from "../../helpers";
import { AnswerHelper } from "../../helpers/AnswerHelper";
import { Answers } from "./Answers"

interface Props {
  questions?: QuestionInterface[],
  answers?: AnswerInterface[],
  messageId?: number,
  playlistId?: number,
  overlayId?: number,
  sendCommand?: (cmd: PendingCommand) => void
}

export const RootAnswers: React.FC<Props> = props => {
  const [questions, setQuestions] = React.useState<QuestionInterface[]>(null);
  const [answers, setAnswers] = React.useState<AnswerInterface[]>(null);

  const loadQuestions = () => {
    if (props.questions) setQuestions(AnswerHelper.buildQuestionTree(props.questions, 0));
  }

  const loadAnswers = () => {
    if (props.answers && props.questions) {
      const result = props.answers;
      props.questions.forEach(q => {
        const existing = ArrayHelper.getOne(result, "questionId", q.id);
        if (!existing) {
          result.push({ questionId: q.id, messageId: props.messageId, playlistId: props.playlistId, overlayId: props.overlayId, id: 0, value: q.placeholder })
        }
      })
      setAnswers(result);
    }
  }


  const handleValueUpdate = (questionId: number, newValue: string) => {
    const result = [...answers];
    const item = ArrayHelper.getOne(result, "questionId", questionId);
    item.value = newValue;
    setAnswers(result);
    props.sendCommand({ action: "updatePreview", parameter: { questions, answers } });;
  }

  React.useEffect(loadQuestions, [props.questions]); // eslint-disable-line
  React.useEffect(loadAnswers, [props.questions, props.answers]); // eslint-disable-line


  const getContent = () => {
    if (!questions) return <Loading />
    else return <Answers questions={questions} answers={answers} updateValue={handleValueUpdate} sendCommand={props.sendCommand} />
  }

  return (
    <>
      {getContent()}
    </>
  );
}